<style scoped lang="scss" type="text/scss">
    .role-container {
        display: flex;
        align-items: flex-start;
        margin-top: 1rem;

        .right-panel {
            width: 23rem;
        }

        .left-panel {
            flex: 1;
            margin-right: 1rem;

            .submit-buttons {
                margin-top: 1rem;
            }
        }

        .drag-wrap {
            .drag-container {
                min-height: 3rem;
                display: flex;
                flex-wrap: wrap;
                margin: -.5rem -.5rem 0 0;

                .ticket-item {
                    margin: .5rem .5rem 0 0;

                    &:hover {
                        cursor: move;
                    }
                }
            }
        }

        .info-panel {
            margin-bottom: 1rem;

            &:not(:first-of-type) {
                margin-top: 1rem;
            }
        }
    }
</style>

<template>
    <div class="role-wrap">
        <registrable-manged-player-selector></registrable-manged-player-selector>
        <div class="role-container">
            <div class="left-panel">
                <info-panel class="info-panel">请完成参赛队成员的身份指定（ 注意：待选人员如不指定身份，将无法颁发证书 ）</info-panel>
<!--                <block-divider>领队指导教师（ 唯一 ）</block-divider>-->
<!--                <card class="drag-wrap">-->
<!--                    <draggable v-model="teacherLeader" class="drag-container can-drag-teacher"-->
<!--                               capacity="1"-->
<!--                               :options="{group:'people'}" :move="checkMove">-->
<!--                        <ticket class="ticket-item" v-for="(item, index) in teacherLeader" :key="index"-->
<!--                                :role="item.personal_role"-->
<!--                                :gender="item.personal_gender" :deletable="true" @remove="remove(teacherLeader, index)">-->
<!--                            {{item.personal_name}}-->
<!--                        </ticket>-->
<!--                    </draggable>-->
<!--                </card>-->
                <block-divider>指导教师</block-divider>
                <card class="drag-wrap">
                    <draggable v-model="normalTeachers" class="drag-container can-drag-teacher"
                               :options="{group:'people'}" :move="checkMove">
                        <ticket class="ticket-item" v-for="(item, index) in normalTeachers" :key="index"
                                :role="item.personal_role"
                                :gender="item.personal_gender" :deletable="true" @remove="remove(normalTeachers, index)">
                            {{item.personal_name}}
                        </ticket>
                    </draggable>
                </card>

<!--                <info-panel class="info-panel">注意：学生队长有入队审批、成员管理、信息填报等权限，不可更改</info-panel>-->
<!--                <block-divider>学生队长（ 必填、唯一 、不可修改）</block-divider>-->

                <info-panel class="info-panel">注意：若学生队长发生更换，原队长将失去入队审批、成员管理、信息填报等权限</info-panel>
                <block-divider>学生队长（ 必填、唯一 ）</block-divider>

                <card class="drag-wrap">
                    <draggable v-model="studentLeader" class="drag-container can-drag-student"
                               capacity="1"
                               :options="{group:'people'}" :move="checkMove">
                        <ticket class="ticket-item" v-for="(item, index) in studentLeader" :key="index"
                                :role="item.personal_role"
                                :gender="item.personal_gender" :deletable="true" @remove="remove(studentLeader, index)">
                            {{item.personal_name}}
                        </ticket>
                    </draggable>
                </card>
                <block-divider>学生队员</block-divider>
                <card class="drag-wrap">
                    <draggable v-model="normalStudents" class="drag-container can-drag-student"
                               :options="{group:'people'}" :move="checkMove">
                        <ticket class="ticket-item" v-for="(item, index) in normalStudents" :key="index"
                                :role="item.personal_role"
                                :gender="item.personal_gender" :deletable="true" @remove="remove(normalStudents, index)">
                            {{item.personal_name}}
                        </ticket>
                    </draggable>
                </card>

<!--                <info-panel class="info-panel">（ 可选 ）请指定团队顾问。注：组委会暂不会为顾问发放证书</info-panel>-->
<!--                <block-divider>团队顾问（ 学生及教师均可成为顾问 ）</block-divider>-->
<!--                <card class="drag-wrap">-->
<!--                    <draggable v-model="consultants" class="drag-container can-drag-student can-drag-teacher"-->
<!--                               :options="{group:'people'}" :move="checkMove">-->
<!--                        <ticket class="ticket-item" v-for="(item, index) in consultants" :key="index"-->
<!--                                :role="item.personal_role"-->
<!--                                :gender="item.personal_gender" :deletable="true" @remove="remove(consultants, index)">-->
<!--                            {{item.personal_name}}-->
<!--                        </ticket>-->
<!--                    </draggable>-->
<!--                </card>-->

                <div class="submit-buttons">
                    <el-button type="primary" plain @click="update()" :loading="requesting">保存</el-button>
                    <el-button @click="reset()">重置</el-button>
                </div>
            </div>
            <div class="right-panel">
                <info-panel class="info-panel">请拖拽卡贴至左侧以指定成员职责</info-panel>

                <block-divider>待选教师</block-divider>
                <card class="drag-wrap">
                    <draggable v-model="candidateTeachers" class="drag-container can-drag-teacher"
                               :options="{group:'people'}" :move="checkMove">
                        <ticket class="ticket-item" v-for="(item, index) in candidateTeachers" :key="index"
                                :role="item.personal_role"
                                :gender="item.personal_gender">
                            {{item.personal_name}}
                        </ticket>
                    </draggable>
                </card>
                <block-divider>待选学生</block-divider>
                <card class="drag-wrap">
                    <draggable v-model="candidateStudents" class="drag-container can-drag-student"
                               :options="{group:'people'}" :move="checkMove">
                        <ticket class="ticket-item" v-for="(item, index) in candidateStudents" :key="index"
                                :role="item.personal_role"
                                :gender="item.personal_gender">
                            {{item.personal_name}}
                        </ticket>
                    </draggable>
                </card>
            </div>

            <count-down></count-down>
        </div>
    </div>
</template>

<script>
    import InfoPanel from '../../../../components/info-panel/index';
    import BlockDivider from '../../../../components/divider/block';
    import Card from '../../../../components/card/index';
    import Draggable from 'vuedraggable';
    import Ticket from '../../../../components/ticket/index';
    import {hasClass} from '../../../../utils/dom';
    import CountDown from '../../../sub-components/count-down/index';
    import {ROLE_VALUE_MAP} from '../../../../constant/role';
    import RegistrableMangedPlayerSelector from '../../../sub-components/registrable-managed-player-selector';
    import {mapState} from 'vuex';
    import _ from 'lodash';

    export default {
        name: '',
        components: {
            InfoPanel,
            BlockDivider,
            Card,
            Draggable,
            Ticket,
            CountDown,
            RegistrableMangedPlayerSelector
        },
        data () {
            return {
                oldStudentLeader: [],
                candidateTeachers: [],
                candidateStudents: [],
                studentLeader: [],
                teacherLeader: [],
                normalStudents: [],
                normalTeachers: [],
                consultants: [],
                requesting: false
            };
        },
        computed: {
            ...mapState('player', {
                currentManagedPlayerId: state => state.currentManagedPlayerId,
                currentManagedPlayerMembers: state => state.currentManagedPlayerMembers,
                currentManagedPlayerCandidateStudents: state => state.currentManagedPlayerCandidateStudents,
                currentManagedPlayerCandidateTeachers: state => state.currentManagedPlayerCandidateTeachers,
                currentManagedPlayerTeacherLeader: state => state.currentManagedPlayerTeacherLeader,
                currentManagedPlayerStudentLeader: state => state.currentManagedPlayerStudentLeader,
                currentManagedPlayerNormalTeachers: state => state.currentManagedPlayerNormalTeachers,
                currentManagedPlayerNormalStudents: state => state.currentManagedPlayerNormalStudents,
                currentManagedPlayerConsultants: state => state.currentManagedPlayerConsultants
            })
        },
        watch: {
            currentManagedPlayerId: {
                immediate: true,
                handler (currentManagedPlayerId) {
                    if (currentManagedPlayerId === null || currentManagedPlayerId === undefined) return;
                    this.loadMembers();
                }
            },
            currentManagedPlayerMembers: {
                immediate: true,
                handler () {
                    this.resetVariables();
                }
            }
        },
        methods: {
            update () {
                if (this.studentLeader.length === 0) {
                    this.$tip('必须指定学生队长');
                    return;
                }
                const shouldReLogin = this.isStudentLeaderChanged();
                const params = {
                    id: this.currentManagedPlayerId,
                    teacher_leader: _.get(this.teacherLeader[0], 'personal.id', null),
                    normal_teachers: _.map(this.normalTeachers, 'personal.id'),
                    student_leader: _.get(this.studentLeader[0], 'personal.id', null),
                    normal_students: _.map(this.normalStudents, 'personal.id'),
                    consultants: _.map(this.consultants, 'personal.id')
                };
              if (shouldReLogin) {
                this.$normalConfirm('学生队长更换确认', '学生队长更换后，您将失去参赛队管理权限（ 该权限会移交至新指定的学生队长 ）。更新成功后，您需要重新登录系统。确认更新？').then(_ => {
                  this.$normalRequest('player/assignMembers', params, '更新成功，请重新登录', true, this, 'requesting').then(_ => {
                    this.$store.dispatch('auth/logout').then();
                  }).catch(_ => {
                  });
                }).catch(_ => {
                });
              }
                 else {
                    this.$normalRequest('player/assignMembers', params, '更新成功', true, this, 'requesting').then(_ => {
                        this.loadMembers();
                    }).catch(_ => {
                    });
                }
            },
            reset () {
                this.resetVariables();
            },
            resetVariables () {
                this.oldStudentLeader = _.cloneDeep(this.currentManagedPlayerStudentLeader);
                this.candidateStudents = _.cloneDeep(this.currentManagedPlayerCandidateStudents);
                this.candidateTeachers = _.cloneDeep(this.currentManagedPlayerCandidateTeachers);
                this.teacherLeader = _.cloneDeep(this.currentManagedPlayerTeacherLeader);
                this.studentLeader = _.cloneDeep(this.currentManagedPlayerStudentLeader);
                this.normalStudents = _.cloneDeep(this.currentManagedPlayerNormalStudents);
                this.normalTeachers = _.cloneDeep(this.currentManagedPlayerNormalTeachers);
                this.consultants = _.cloneDeep(this.currentManagedPlayerConsultants);
            },
            isStudentLeaderChanged () {
                if (_.get(this.oldStudentLeader[0], 'personal.id', null) === _.get(this.studentLeader[0], 'personal.id', null)) {
                    return false;
                } else {
                    return true;
                }
            },
            loadMembers () {
                this.$store.dispatch('player/loadMembers', {
                    id: this.currentManagedPlayerId
                }).then(response => {
                });
            },
            checkMove: function (event) {
                const to = event.to;
                const capacity = to.getAttribute('capacity') || null;
                const target = event.relatedContext.list;
                const current = event.draggedContext.element;
                if (capacity !== null && target.length >= capacity) {
                    return false;
                }
                if (current.personal_role === ROLE_VALUE_MAP.TEACHER && hasClass(to, 'can-drag-teacher')) {
                    return true;
                }
                if (current.personal_role === ROLE_VALUE_MAP.STUDENT && hasClass(to, 'can-drag-student')) {
                    return true;
                }
                return false;
            },
            remove (origin, index) {
                const target = origin.splice(index, 1)[0];
                if (target.personal_role === ROLE_VALUE_MAP.TEACHER) {
                    this.candidateTeachers.push(target);
                }
                if (target.personal_role === ROLE_VALUE_MAP.STUDENT) {
                    this.candidateStudents.push(target);
                }
            }
        }
    };
</script>
